import { type ReactNode } from 'react';

import { cn } from '@/util/utils';

/*
  The bulk bar a card's head turns into while rows are selected (scripts/screens/lookbook-new.js,
  `lbn-bulk`): how many are selected, out of how many, a way to clear the selection, and the
  actions that apply to all of them. The caller words the count, since only it knows the noun.
*/

export interface SelectionBarProps {
    /** "3 pages selected". */
    selected: string;
    /** "of 20". */
    total: string;
    clearLabel?: string;
    onClear: () => void;
    /** The buttons for the selected rows, on the right. */
    actions?: ReactNode;
    className?: string;
}

export function SelectionBar({
    selected,
    total,
    clearLabel = 'Clear selection',
    onClear,
    actions,
    className,
}: SelectionBarProps) {
    return (
        <div
            data-slot="selection-bar"
            role="group"
            aria-label={selected}
            className={cn('flex w-full flex-wrap items-center gap-x-3 gap-y-2', className)}
        >
            <span className="text-label-md text-foreground" aria-live="polite">
                {selected}
            </span>
            <span className="text-muted-foreground text-xs">{total}</span>
            <span className="flex-1" />
            {/* The prototype's data-table link: body text, not the condensed label face buttons use. */}
            <button
                type="button"
                onClick={onClear}
                className="text-foreground text-sm hover:underline pointer-coarse:min-h-11"
            >
                {clearLabel}
            </button>
            {actions}
        </div>
    );
}
